import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import relativeTime from "dayjs/plugin/relativeTime"
import isBetween from "dayjs/plugin/isBetween"
import calendar from "dayjs/plugin/calendar"
import duration from "dayjs/plugin/duration"
import isoWeek from "dayjs/plugin/isoWeek"
import weekOfYear from "dayjs/plugin/weekOfYear"
import weekday from "dayjs/plugin/weekday"
import localizedFormat from "dayjs/plugin/localizedFormat"
import updateLocale from "dayjs/plugin/updateLocale"
import "dayjs/locale/de"

dayjs.extend(utc)
dayjs.extend(relativeTime)
dayjs.extend(isBetween)
dayjs.extend(calendar)
dayjs.extend(duration)
dayjs.extend(isoWeek)
dayjs.extend(weekOfYear)
dayjs.extend(weekday)
dayjs.extend(localizedFormat)
dayjs.extend(updateLocale)

// the dayjs "de" locale has no calendar texts, these are the ones of the moment.js "de" locale
dayjs.updateLocale("de", {
	calendar: {
		sameDay: "[heute um] LT [Uhr]",
		sameElse: "L",
		nextDay: "[morgen um] LT [Uhr]",
		nextWeek: "dddd [um] LT [Uhr]",
		lastDay: "[gestern um] LT [Uhr]",
		lastWeek: "[letzten] dddd [um] LT [Uhr]",
	},
})
dayjs.locale('de')

export { dayjs }
